import { toRem } from "theme/Breakpoints";
import { colors } from "theme/Theme";

export const headerButtonStyles = `
  border-style: solid;
  border-width: 1.5px;
  border-color: ${colors.light_blue};
  width: ${toRem(120)};
  height: ${toRem(40)};
  display: inline-flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  padding: 5px;
  margin: 0 10px;

  &:hover {
    border-width: 2.5px;
  }
`;
